import '@/assets/vendor/nucleo/css/nucleo.css';
import '@/assets/vendor/font-awesome/css/all.css';
//import '@/fonts/_fonts.css';
import '@/assets/scss/argon.scss';

import globalComponents from './globalComponents';
import globalDirectives from './globalDirectives';
import Notifications from '../components/NotificationPlugin';
import VueLazyload from 'vue-lazyload';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

export default {
	install(Vue) {
		Vue.use(globalComponents);
		Vue.use(globalDirectives);
		Vue.use(Notifications);
		Vue.use(BootstrapVue);
		Vue.use(IconsPlugin);
		Vue.use(VueLazyload);
	},
};
